//createEditUsername component

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openResetPasswordDriverModal, resetPasswordDriverAction, createDriverFSMAction } from "./redux/slices";
import { useIntl } from "react-intl";
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button } from "@gpstrackit/gtc-react-controls";
import PasswordDriverFields from "../passwordDriverFields";
import { NotificationManager } from "Components/Notifications";


const ResetPasswordDriver = ({ callback }) => {
  const {openResetPasswordDriver, driver, response} = useSelector(
    (state) => state.driverResetPasswordSliceRedux
  );
  const loading = useSelector(
    (state) => state.driverResetPasswordSliceRedux.loading
  );

  const [errorMatchPassword, setErrorMatchPassword] = useState(null);
  const isNewDriver = driver?.fsmDriver?.username === null;
  const [formData, setFormData] = useState({
    username: driver?.fsmDriver?.username,
    password: driver?.fsmDriver?.password,
    driverId: driver?.driverId,
    hasVideoAccess: !!driver?.fsmDriver?.hasVideoAccess
  });

  useEffect(() => {
    if (response) {
      NotificationManager.success(
        messages["settingsDriver_resetPasswordSuccess"],
        messages["success"],
        3000,
        null,
        null,
        "success"
      );
      callback && callback();
      dispatch(openResetPasswordDriverModal({ open: false, driverId: null, response: null }));
    }
  }, [response]);

  const dispatch = useDispatch();
  const {messages} = useIntl();

  const handleSave = () => {

    if (!formData?.username) {
      NotificationManager.warning(
        messages["settingsDriver_invalidUsername"],
        messages["warning"],
        3000,
        null,
        null,
        "warning"
      );
      return;
    }

    if (!formData?.password) {
      NotificationManager.warning(
        messages["settingsDriver_passwordRequiredToCreateOrEdit"],
        messages["warning"],
        3000,
        null,
        null,
        "warning"
      );
      return;
    }

    if (formData?.username?.length < 4 || formData?.username?.length > 12) {
      NotificationManager.warning(
        messages["settingsDriver_invalidUsernameLength"],
        messages["warning"],
        3000,
        null,
        null,
        "warning"
      );
      return;
    }

    if (formData?.password !== formData?.repeatPassword) {
      setErrorMatchPassword(
        messages["settingsDriver_repeatPasswordDoNotMatch"]
      );
      return;
    }

    const data = {
      driverId: formData?.driverId,
      username: formData?.username,
      password: formData?.password,
      hasVideoAccess: !!formData?.hasVideoAccess
    }

    if (isNewDriver) {
      dispatch(createDriverFSMAction({...data, defaultTab: "map"}));
    } else {
      dispatch(resetPasswordDriverAction(data));
    }
  }

  return (
    <>
      <Modal
        title={messages["settingsDriver_resetPassword"]}
				open={openResetPasswordDriver}
				size="small"
				handleClose={() => dispatch(openResetPasswordDriverModal({ open: false, driverId: null }))}
				position="right"
				loading={loading}
      >
        <ModalBody style={{padding: '16px'}}>
          <PasswordDriverFields
            formData={formData}
            isRequiredUsername={true}
            setFormData={setFormData}
            hideHeader={true}
            errorMatchPassword={errorMatchPassword}
          />
        </ModalBody>
        <ModalFooter>
            <Button
              onClick={() => dispatch(openResetPasswordDriverModal({ open: false, driverId: null }))} 
              className="btn-cancel"
              style={{marginRight: 10}}
              variant="secondary"
            >
              {messages["cancel"]}
            </Button>
            <Button
              id="btn-schedule"
              type="button"
              variant="primary"
              onClick={(e) => {
                if (e) e.preventDefault();
                handleSave();
              }}
              className="btn-blue"
            >
              {messages["save"]}
            </Button>
				</ModalFooter>
      </Modal>
    </>
  );
};

export default ResetPasswordDriver;
